import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import ExitButton from "../buttons/ExitButton";
import UserModal from "../modal/UserModal";
import accountSVG from "../../images/account.svg";
import InputImage from "../inputs/InputImage";
import {loadCurrentUser} from "../user/usersAction";
import {BaseModal} from "../modal/modalStyle";
import {PurpleReverseButton} from "../buttons/ButtonStyles";
import useImageChange from "../../custom-hooks/useImageChange";

const CurrentUserAccount = () => {
    const dispatch = useDispatch()
    const {id, firstName, lastName, phone, email, photo} = useSelector(state => state.currentUser)
    const [editModalOpen, setEditModalOpen] = useState(false)
    const navigate = useNavigate();


    const {imageSize, lengthError, image, onImageChange} = useImageChange(id, photo, accountSVG, "users")



    useEffect(() => {
        document.body.style.overflow = "hidden"
        return function cleanup() {
            document.body.style.overflow = "auto"
        }
    }, [])


    const imageChange = async (e) => {
        await onImageChange(e)
        dispatch(loadCurrentUser(id))
    }

    const userAccount = useRef()

    const closePopup = () => {
        userAccount.current.classList.toggle("animate-hidden")
        navigate(-1);
    }

    const exitDetailHandler = (e) => {
        const element = e.target;
        if (element.classList.contains('shadow')) {
            closePopup()
        }
    }

    const openEditUser = () => {
        setEditModalOpen(true)
    }

    return (
        <div className={"shadow"} onClick={exitDetailHandler}>
            <UserAccount ref={userAccount}>
                <ExitButton
                    closeUpdate={closePopup}
                />
                <MainPart>
                    <InfoWrapper>
                        <MainInfo>
                            <InputImage
                                image={image}
                                onChange={imageChange}
                                name={"utilisateur courant"}
                            />
                            <UserInfo>
                                <h1> {firstName} {lastName}</h1>
                                <p> {email} </p>
                                <p> {phone} </p>
                            </UserInfo>
                        </MainInfo>
                        <div>
                            {lengthError &&
                            <p className={"error-text"}> La taille de votre image est trop importante, veuillez
                                choisir une taille inférieure à 1Mo ({imageSize})</p>
                            }
                        </div>
                        <Button onClick={openEditUser}>
                            <h6> Éditer le profil </h6>
                        </Button>
                    </InfoWrapper>

                </MainPart>
                {editModalOpen &&
                <UserModal
                    setModalIsOpen={setEditModalOpen}
                    isEditAction={true}
                    isCurrentUser={true}
                />
                }
            </UserAccount>
        </div>
    )
}
const UserAccount = styled(BaseModal)`
  display: flex;
  position: absolute;
  transform: scale(1);
  animation: popin 0.5s ease-out;
  background: var(--color-white);
  margin: auto;
  align-items: center;
  transition: all 0.5s ease-out;
  height: fit-content;

  .exit-btn {
    align-self: flex-end;
  }

  @media (min-width: 700px) {
    width: 40rem;
  }`
const MainPart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1rem;

  p {
    font-size: 12px;
  }
`
const InfoWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`
const MainInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;
  width: 100%;
  @media (min-width: 550px) {
    align-items: center;
  }
  @media (min-width: 700px) {
    flex-direction: row;
  }
`
const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  //padding: 1em 0;

  h1 {
    font-weight: 800;
    font-size: 2em;
  }

  p {
    font-weight: 600;
  }

  @media (min-width: 550px) {
    align-items: flex-start;
    gap: 0.3em;
  }
  @media (min-width: 700px) {
    align-items: flex-start;
    gap: 0.3em;
  }
`
const Button = styled(PurpleReverseButton)`
`


export default CurrentUserAccount;